import React from 'react';
import { render } from 'react-dom';

import normalizeCss from 'html5-boilerplate/dist/css/main.css';
import boilerplateCss from 'html5-boilerplate/dist/css/normalize.css';
import skeletonCss from 'skeleton-css/css/skeleton.css';

import AOS from 'aos';

import aosStyles from 'aos/dist/aos.css';
import router from './config/routes';

AOS.init({
  duration: 200
});


render(router, document.getElementById('app'));



// WEBPACK FOOTER //
// ./app/index.js